/** Which inputs the contact form renders. */
export type ContactInfoFields = 'email' | 'nameAndEmail';

/**
 * What a contact step showed the customer. Every contact Heap event (Viewed / Skipped /
 * Completed, in both sign-in and start-visit onboarding) carries it, so conversion can be split
 * by fields shown × optional badge, and by whether the visible fields arrived already filled in.
 */
export type ContactInfoDisplay = {
  /** The email input was filled in from the account or invite when the step opened. */
  emailPrefilled: boolean;
  fieldsShown: ContactInfoFields;
  /** A visible name input was filled in when the step opened — always false in email-only mode. */
  namePrefilled: boolean;
  optionalBadgeShown: boolean;
};

export function contactInfoDisplay({
  defaultValues,
  fields,
  showOptionalBadge,
}: {
  defaultValues: { email?: string; firstName?: string; lastName?: string };
  fields: ContactInfoFields;
  showOptionalBadge: boolean;
}): ContactInfoDisplay {
  return {
    emailPrefilled: !!defaultValues.email,
    fieldsShown: fields,
    namePrefilled:
      fields === 'nameAndEmail' && (!!defaultValues.firstName || !!defaultValues.lastName),
    optionalBadgeShown: showOptionalBadge,
  };
}
